/* ═══════════════════════════════════════════════════════════
   nb-pdp-hero.js
   Gallery view switcher + chaos toggle + bundle selector +
   AJAX add-to-cart that opens the theme's existing drawer.
   No framework dependencies. Runs once per section instance.
   ═══════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  function initPdpHero(root) {
    if (!root || root.dataset.nbInit === '1') return;
    root.dataset.nbInit = '1';

    // ─── Gallery view switcher ──────────────────────────────
    var thumbs = root.querySelectorAll('.nb-pdph-gallery__thumb');
    var main = root.querySelector('.nb-pdph-gallery__main');
    var mainImages = root.querySelectorAll('.nb-pdph-gallery__main-img');

    function setView(view) {
      thumbs.forEach(function (t) {
        t.classList.toggle('is-active', t.getAttribute('data-view') === view);
      });
      mainImages.forEach(function (img) {
        img.classList.toggle('is-hidden', img.getAttribute('data-view') !== view);
      });
      if (main) {
        main.classList.toggle('is-chaos', view === 'chaos');
      }
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var view = t.getAttribute('data-view');
        if (view) setView(view);
      });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          t.click();
        }
      });
    });

    // ─── Thumbnail pagination — match thumb stack to main image height ──
    var thumbsList = root.querySelector('[data-nb-thumbs]');
    var pagerUp = root.querySelector('[data-nb-thumbs-up]');
    var pagerDown = root.querySelector('[data-nb-thumbs-down]');

    function updatePagerVisibility() {
      if (!thumbsList || !pagerUp || !pagerDown) return;
      var overflow = thumbsList.scrollHeight - thumbsList.clientHeight > 4;
      pagerUp.hidden = !overflow;
      pagerDown.hidden = !overflow;
      if (!overflow) return;
      pagerUp.disabled = thumbsList.scrollTop <= 2;
      pagerDown.disabled = thumbsList.scrollTop + thumbsList.clientHeight >= thumbsList.scrollHeight - 2;
    }

    function syncThumbsCap() {
      if (!thumbsList || !main) return;
      if (window.matchMedia('(max-width: 1024px)').matches) {
        thumbsList.style.maxHeight = '';
        if (pagerUp) pagerUp.hidden = true;
        if (pagerDown) pagerDown.hidden = true;
        return;
      }
      var mainH = main.getBoundingClientRect().height;
      if (mainH > 0) {
        var cap = Math.max(mainH - 68, 220);
        thumbsList.style.maxHeight = cap + 'px';
      }
      updatePagerVisibility();
    }

    function pageThumbs(dir) {
      if (!thumbsList) return;
      var step = 98 * Math.max(1, Math.floor(thumbsList.clientHeight / 98) - 1);
      thumbsList.scrollBy({ top: dir * step, behavior: 'smooth' });
    }

    if (pagerUp) pagerUp.addEventListener('click', function () { pageThumbs(-1); });
    if (pagerDown) pagerDown.addEventListener('click', function () { pageThumbs(1); });
    if (thumbsList) thumbsList.addEventListener('scroll', updatePagerVisibility, { passive: true });

    if (main) {
      requestAnimationFrame(syncThumbsCap);
      window.addEventListener('resize', syncThumbsCap);
      var firstMain = root.querySelector('.nb-pdph-gallery__main-img');
      if (firstMain && !firstMain.complete) firstMain.addEventListener('load', syncThumbsCap, { once: true });
    }

    // ─── Bundle selector + live price + ATC label ───────────
    var options = root.querySelectorAll('.nb-pdph-buy__option');
    var atc = root.querySelector('.nb-pdph-buy__atc');
    var atcLabel = root.querySelector('.nb-pdph-buy__atc-label');
    var variantInput = root.querySelector('.nb-pdph-buy__variant-input');
    var form = root.querySelector('.nb-pdph-buy__form');
    var errorEl = null;

    function ensureErrorEl() {
      if (errorEl && errorEl.isConnected) return errorEl;
      errorEl = root.querySelector('.nb-pdph-buy__error');
      if (!errorEl) {
        errorEl = document.createElement('div');
        errorEl.className = 'nb-pdph-buy__error';
        errorEl.setAttribute('role', 'alert');
        errorEl.hidden = true;
        var actions = root.querySelector('.nb-pdph-buy__actions');
        if (actions && actions.parentNode) {
          actions.parentNode.insertBefore(errorEl, actions);
        }
      }
      return errorEl;
    }

    function showError(msg) {
      var el = ensureErrorEl();
      el.textContent = msg;
      el.hidden = false;
    }

    function clearError() {
      if (errorEl) {
        errorEl.hidden = true;
        errorEl.textContent = '';
      }
    }

    // Capture the original first-slide image once, so we can restore when an
    // option without a custom image is reselected.
    var firstSlideImg = root.querySelector('.nb-pdph-gallery__slide [data-view] , .nb-pdph-gallery__main-img');
    var firstSlideOriginal = null;
    if (firstSlideImg) {
      firstSlideOriginal = {
        src: firstSlideImg.getAttribute('src') || '',
        srcset: firstSlideImg.getAttribute('srcset') || '',
        alt: firstSlideImg.getAttribute('alt') || ''
      };
    }

    function swapGalleryHero(opt) {
      if (!firstSlideImg) return;
      var url = opt.getAttribute('data-variant-image') || '';
      var srcset = opt.getAttribute('data-variant-image-srcset') || '';
      var alt = opt.getAttribute('data-variant-image-alt') || '';
      if (url) {
        firstSlideImg.removeAttribute('data-srcset');
        firstSlideImg.removeAttribute('data-src');
        firstSlideImg.src = url;
        if (srcset) firstSlideImg.srcset = srcset; else firstSlideImg.removeAttribute('srcset');
        if (alt) firstSlideImg.alt = alt;
      } else if (firstSlideOriginal) {
        firstSlideImg.src = firstSlideOriginal.src;
        if (firstSlideOriginal.srcset) firstSlideImg.srcset = firstSlideOriginal.srcset; else firstSlideImg.removeAttribute('srcset');
        if (firstSlideOriginal.alt) firstSlideImg.alt = firstSlideOriginal.alt;
      }
      // Reset gallery view to slide 1 (desktop) and scroll to start (mobile).
      var firstView = firstSlideImg.getAttribute('data-view');
      if (firstView !== null && typeof setView === 'function') {
        try { setView(firstView); } catch (e) {}
      }
      var track = root.querySelector('.nb-pdph-gallery__track');
      if (track && typeof track.scrollTo === 'function') {
        try { track.scrollTo({ left: 0, behavior: 'auto' }); } catch (e) {}
      }
    }

    function selectOption(opt) {
      // Sold-out pills are display-only: never selectable, never the ATC target.
      if (opt.classList.contains('is-soldout')) return;
      options.forEach(function (o) { o.classList.remove('is-active'); });
      opt.classList.add('is-active');

      var input = opt.querySelector('.nb-pdph-buy__option-input');
      if (input) input.checked = true;

      var variantId = opt.getAttribute('data-variant-id');
      var optionName = opt.getAttribute('data-option-name') || 'bundle';

      if (variantInput && variantId) variantInput.value = variantId;

      if (atcLabel) {
        atcLabel.textContent = 'Add ' + optionName + ' to cart';
      }

      if (atc) {
        atc.disabled = !variantId;
      }

      swapGalleryHero(opt);
    }

    options.forEach(function (opt) {
      opt.addEventListener('click', function (e) {
        if (opt.classList.contains('is-soldout')) { e.preventDefault(); return; }
        if (e.target && e.target.classList && e.target.classList.contains('nb-pdph-buy__option-input')) return;
        selectOption(opt);
      });
    });

    // ─── Sticky bar bridge: mirror pill selection into the hero buy panel ───
    // The sticky bars (mobile + desktop) dispatch `nuvie:sticky-select` with
    // { handle } when a shopper picks a bundle pill. Match by /products/<handle>
    // tail of data-product-url and re-run the same selectOption flow — this
    // updates active state, variant input, ATC label, and hero gallery image.
    document.addEventListener('nuvie:sticky-select', function (e) {
      if (!e.detail || !e.detail.handle) return;
      var handle = e.detail.handle;
      var suffix = '/products/' + handle;
      for (var i = 0; i < options.length; i++) {
        var url = options[i].getAttribute('data-product-url') || '';
        if (url === suffix || url.indexOf(suffix) !== -1) {
          if (!options[i].classList.contains('is-active') && !options[i].classList.contains('is-soldout')) {
            selectOption(options[i]);
          }
          break;
        }
      }
    });

    // ─── URL param pre-select (deep-link from homepage bundle cards) ───
    // Homepage nuvie-bundle-cards links to /products/nuviebaby-clean?bundle=<value>
    // where <value> matches the nb_bundle radio value (machine | clean-365 | clean-730).
    // If a valid bundle param is present, pre-select that option instead of the default.
    var urlBundle = null;
    try {
      urlBundle = new URLSearchParams(window.location.search).get('bundle');
    } catch (e) { urlBundle = null; }

    var preselectOpt = null;
    if (urlBundle) {
      for (var i = 0; i < options.length; i++) {
        var radio = options[i].querySelector('.nb-pdph-buy__option-input');
        if (radio && radio.value === urlBundle && !options[i].classList.contains('is-soldout')) {
          preselectOpt = options[i];
          break;
        }
      }
    }

    // ─── Initialize active option (URL param wins, then .is-active, then first in stock) ───
    var defaultOpt = preselectOpt
      || root.querySelector('.nb-pdph-buy__option.is-active')
      || root.querySelector('.nb-pdph-buy__option:not(.is-soldout)');
    if (defaultOpt) {
      selectOption(defaultOpt);
    } else if (atc) {
      // Everything sold out: liquid renders no ATC, but belt-and-braces.
      atc.disabled = true;
    }

    // ─── Warranty modal (Wave C: post-ATC bottom-sheet) ─────
    // Form submit opens the modal first; modal's "pick" buttons resolve
    // a warranty variant id (or 0 for "no thanks") then trigger cart add.
    // Portal the modal element OUT of the buy panel to <body> so its
    // position:fixed escapes the gallery's stacking context and sits
    // above all other PDP content.
    var warModal = root.querySelector('[data-nb-warmodal]');
    if (warModal && warModal.parentNode !== document.body) {
      document.body.appendChild(warModal);
    }
    var pendingSubmit = null;
    var lastFocusBeforeModal = null;

    function openWarrantyModal(onResolve) {
      if (!warModal) { onResolve(0); return; }
      pendingSubmit = onResolve;
      lastFocusBeforeModal = document.activeElement;
      warModal.hidden = false;
      // Force reflow so the transition kicks in
      // eslint-disable-next-line no-unused-expressions
      warModal.offsetHeight;
      warModal.classList.add('is-open');
      warModal.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      // Focus the first option for keyboard users
      var firstOpt = warModal.querySelector('[data-nb-warmodal-pick]');
      if (firstOpt) firstOpt.focus();
    }

    function closeWarrantyModal(resolveWith) {
      if (!warModal) return;
      warModal.classList.remove('is-open');
      warModal.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      var resolver = pendingSubmit;
      pendingSubmit = null;
      // Allow CSS transition to play out before hiding
      setTimeout(function () {
        if (!warModal.classList.contains('is-open')) {
          warModal.hidden = true;
        }
      }, 350);
      if (lastFocusBeforeModal && typeof lastFocusBeforeModal.focus === 'function') {
        lastFocusBeforeModal.focus();
      }
      if (resolver) resolver(resolveWith || 0);
    }

    if (warModal) {
      // Pick buttons resolve with a warranty variant id (or 0 for none)
      warModal.querySelectorAll('[data-nb-warmodal-pick]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var vid = btn.getAttribute('data-warranty-variant-id');
          var variantId = vid ? parseInt(vid, 10) : 0;
          closeWarrantyModal(variantId || 0);
        });
      });

      // Overlay + close icon dismiss = "no thanks"
      warModal.querySelectorAll('[data-nb-warmodal-close]').forEach(function (el) {
        el.addEventListener('click', function () {
          closeWarrantyModal(0);
        });
      });

      // Escape key dismisses
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && warModal.classList.contains('is-open')) {
          closeWarrantyModal(0);
        }
      });
    }

    // ─── Open the theme's existing cart drawer ──────────────
    function openCartDrawer() {
      // 1) Trigger Minimog's custom element .open() if present
      var drawer = document.querySelector('m-cart-drawer');
      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
        return;
      }
      // 2) Fallback: click the header cart icon
      var cartIcon = document.querySelector('.m-cart-icon-bubble, [data-cart-toggle], .m-cart-icon, .header__icon--cart');
      if (cartIcon) {
        cartIcon.click();
        return;
      }
      // 3) Fallback: navigate to /cart
      window.location.href = '/cart';
    }

    // Refresh cart drawer contents via Shopify sections API so the
    // drawer shows the newly-added line item without a full reload.
    function refreshCartSections() {
      return fetch('/?sections=cart-drawer,cart-icon-bubble', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          if (!data) return;
          if (data['cart-drawer']) {
            var drawerHost = document.querySelector('m-cart-drawer');
            if (drawerHost) {
              var temp = document.createElement('div');
              temp.innerHTML = data['cart-drawer'];
              var fresh = temp.querySelector('m-cart-drawer');
              if (fresh) drawerHost.innerHTML = fresh.innerHTML;
            }
          }
          if (data['cart-icon-bubble']) {
            var bubble = document.querySelector('#cart-icon-bubble, .m-cart-icon-bubble .m-cart-count, [data-cart-count]');
            if (bubble) {
              var tempB = document.createElement('div');
              tempB.innerHTML = data['cart-icon-bubble'];
              var inner = tempB.firstElementChild;
              if (inner) bubble.innerHTML = inner.innerHTML;
            }
          }
        })
        .catch(function () { /* silent */ });
    }

    // ─── ATC: intercept submit, open warranty modal, then POST ──
    // Uses multipart/form-data (matches Minimog stock ProductForm) so that
    // Shopify Bundle parent variants are properly resolved into components.
    // JSON requests bypass bundle resolution and fail with "is sold out".
    function performCartAdd(bundleId, warrantyVariantId) {
      var originalLabel = atcLabel ? atcLabel.textContent : 'Add to cart';
      if (atc) atc.disabled = true;
      if (atcLabel) atcLabel.textContent = 'Adding...';

      var fd = new FormData();
      fd.append('items[0][id]', bundleId);
      fd.append('items[0][quantity]', '1');
      if (warrantyVariantId) {
        fd.append('items[1][id]', warrantyVariantId);
        fd.append('items[1][quantity]', '1');
      }
      fd.append('sections_url', window.location.pathname);

      var cartAddUrl = (window.MinimogSettings && window.MinimogSettings.routes && window.MinimogSettings.routes.cart_add_url)
        || ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart/add.js';

      return fetch(cartAddUrl, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/javascript, application/json'
          },
          body: fd
        })
          .then(function (res) {
            if (!res.ok) {
              return res.json().then(function (err) {
                throw new Error(err && (err.description || err.message) || 'Add to cart failed');
              });
            }
            return res.json();
          })
          .then(function () {
            document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
          })
          .then(function () {
            if (atcLabel) atcLabel.textContent = 'Added';
            setTimeout(function () {
              if (atcLabel) atcLabel.textContent = originalLabel;
              if (atc) atc.disabled = false;
            }, 1500);
          })
          .catch(function (err) {
            showError((err && err.message) ? err.message : 'Something went wrong. Please try again.');
            if (atcLabel) atcLabel.textContent = originalLabel;
            if (atc) atc.disabled = false;
          });
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        clearError();

        var id = variantInput && variantInput.value ? parseInt(variantInput.value, 10) : 0;
        if (!id) {
          showError('Please select a bundle.');
          return;
        }

        // If the warranty modal exists, open it first. Resolves with a
        // warranty variant id (or 0 for "no thanks") then completes ATC.
        if (warModal) {
          openWarrantyModal(function (warrantyVariantId) {
            performCartAdd(id, warrantyVariantId || 0);
          });
        } else {
          performCartAdd(id, 0);
        }
      });
    }
  }

  function bootAll() {
    document.querySelectorAll('[data-nb-pdp-hero]').forEach(initPdpHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }

  // Shopify theme editor re-init
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector('[data-nb-pdp-hero]');
      if (el) initPdpHero(el);
    });
  }
})();
